import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Typography as MuiTypography } from '@mui/material'
import clsx from 'clsx'

const PREFIX = 'Typography'

const classes = {
  error: `${PREFIX}-error`,
  microcopy: `${PREFIX}-microcopy`,
}

const StyledMuiTypography = styled(MuiTypography)(() => {
  return {
    [`&.${classes.error}`]: {
      fontWeight: 400,
      fontSize: 14,
      color: '#CC0000',
    },
    [`&.${classes.microcopy}`]: {
      fontWeight: 300,
      fontSize: 14,
      fontStyle: 'italic',
      color: '#333333',
    },
  }
})

export const Typography = props => {
  const { children, ...other } = props
  let variant = other.variant

  const classOverrides = []
  /* custom variants (unsupported by Typography component), so forwarding
  supported variant "body1" to base component and overriding style with classes */
  switch (variant) {
    case 'error':
      classOverrides.push(classes.error)
      variant = 'body1'
      break
    case 'microcopy':
      classOverrides.push(classes.microcopy)
      variant = 'body1'
      break
    default:
      break
  }

  return (
    <StyledMuiTypography
      className={clsx(...classOverrides)}
      {...other}
      variant={variant}
    >
      {children}
    </StyledMuiTypography>
  )
}

export default Typography
